// extracted by mini-css-extract-plugin
export default {"heading":"TeamMemberParents_heading__b+apr"};